/**
 * Series – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Series menu icon. */
export default function SeriesIcon({ focused, height, width }: Props) {
  const color = Colors['menu']['icon'][focused ? 'focused' : 'unfocused'];
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || 22 * Screen.widthRatio}
      height={height || 23 * Screen.widthRatio}
      viewBox={'0 0 22 23'}
      fill='none'
    >
      <path
        d='M3.35448 23C2.24995 23 1.41474 22.7226 0.848846 22.1677C0.282949 21.6128 0 20.7907 0 19.7012V9.26699C0 8.17755 0.282949 7.3554 0.848846 6.80053C1.41474 6.24566 2.24995 5.96823 3.35448 5.96823H18.2553C19.3598 5.96823 20.195 6.24904 20.7609 6.81068C21.3336 7.36555 21.62 8.18432 21.62 9.26699V19.7012C21.62 20.7839 21.3336 21.6027 20.7609 22.1575C20.195 22.7192 19.3598 23 18.2553 23H3.35448ZM3.4772 21.0106H18.1326C18.603 21.0106 18.9644 20.8854 19.2166 20.635C19.4757 20.3914 19.6053 20.0227 19.6053 19.5287V9.43954C19.6053 8.94557 19.4757 8.57679 19.2166 8.33319C18.9644 8.08282 18.603 7.95763 18.1326 7.95763H3.4772C2.99994 7.95763 2.63517 8.08282 2.3829 8.33319C2.13746 8.57679 2.01473 8.94557 2.01473 9.43954V19.5287C2.01473 20.0227 2.13746 20.3914 2.3829 20.635C2.63517 20.8854 2.99994 21.0106 3.4772 21.0106ZM2.24995 4.31377C2.32495 3.83333 2.49199 3.46117 2.75108 3.19726C3.01698 2.93336 3.42266 2.80141 3.9681 2.80141H17.6519C18.1973 2.80141 18.5996 2.93336 18.8587 3.19726C19.1246 3.46117 19.295 3.83333 19.37 4.31377H2.24995ZM4.33627 1.38041C4.36354 0.927037 4.51013 0.585319 4.77604 0.355252C5.04876 0.118417 5.43057 0 5.92147 0H15.6985C16.1894 0 16.5678 0.118417 16.8337 0.355252C17.0996 0.585319 17.253 0.927037 17.294 1.38041H4.33627Z'
        fill={color}
        stroke={color}
        strokeWidth={focused ? 0.8 : 0.5}
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  );
}
